export default "__VITE_ASSET__DwGvjam6__"